import { createGlobalStyle } from 'styled-components';
import RobotoMonoRegular from '../assets/fonts/RobotoMono-Regular.ttf';
import MontserratSemiBold from '../assets/fonts/Montserrat-SemiBold.ttf';
import MontserratBold from '../assets/fonts/Montserrat-Bold.ttf';
import POPPINSREGULAR from '../assets/fonts/POPPINS-REGULAR.TTF';
import POPPINSMEDIUM from '../assets/fonts/POPPINS-MEDIUM.TTF';
import SegoeUI from '../assets/fonts/Segoe UI.ttf';

const Typography = createGlobalStyle`
  @font-face {
    font-family: 'RobotoMono Regular';
    src: url(${RobotoMonoRegular});
    font-style: normal;
  }
  @font-face {
    font-family: 'Montserrat SemiBold';
    src: url(${MontserratSemiBold});
    font-style: normal;
  }
  @font-face {
    font-family: 'Montserrat Bold';
    src: url(${MontserratBold});
    font-style: normal;
  }
  @font-face {
    font-family: 'POPPINS REGULAR';
    src: url(${POPPINSREGULAR});
    font-style: normal;
  }
   @font-face {
    font-family: 'POPPINS MEDIUM';
    src: url(${POPPINSMEDIUM});
    font-style: normal;
  } 
  @font-face {
    font-family: 'Segoe UI';
    src: url(${SegoeUI});
    font-style: normal;
  }
  html{
    font-family: 'Montserrat SemiBold';
    color: var(--gray-1);
  }
  *{
    font-family: 'RobotoMono Regular';
    color: var(--gray-1);
  }
  h1,h2,h3,h4,h5,h6{
    font-family: 'POPPINS REGULAR'
  }

`;

export default Typography;
